export var accordionStyles = {
  root: function root() {
    return {
      verticalAlign: 'middle',
      display: 'flex',
      flexDirection: 'column',
      marginBlockEnd: 0,
      marginBlockStart: 0
    };
  }
};